import { useState } from "react";
import { DotLegalAlert, DotLegalDialog, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { isNullOrWhitespace } from "@common/stringOperations";

interface AvoidRiskDialogProps {
    inProgress: boolean;
    onClose: () => void;
    onSubmit: (reason: string) => void;
}

// Avoiding the risk from the mitigation overview supersedes (cancels) the open plan, the same way accepting
// does, so the dialog leads with that warning. It posts to the treatment endpoint; the plan then shows as
// Cancelled. Avoidance carries no review-by date, so this is reason-only.
function AvoidRiskDialog({ inProgress, onClose, onSubmit }: AvoidRiskDialogProps) {
    const { translateString } = useTranslation();
    const [reason, setReason] = useState("");

    return (
        <DotLegalDialog
            open
            header={translateString("riskMitigationAvoidDialogTitle")}
            buttonOkText={translateString("riskTreatmentTypeAvoid")}
            onDialogClose={onClose}
            onOkClick={() => onSubmit(reason)}
            okButtonDisabled={isNullOrWhitespace(reason)}
            inProgress={inProgress}
            size={"sm"}
        >
            <DotLegalAlert severity={"warning"} warningText={translateString("riskMitigationAvoidDialogWarning")} />
            <DotLegalTextField label={translateString("justification")} value={reason} onChange={setReason} multiline rows={3} debounce={false} />
        </DotLegalDialog>
    );
}

export default AvoidRiskDialog;
